module.exports = __webpack_public_path__ + "img/13.5d15a1d4.jpg";